import { Passenger } from '@ibe.models/passenger.model.lib';
import { FlightBrand } from '@ibe.models/flight.model.lib';


export interface Ancillaries {
	id: string;
	seat: string;
	luggage: number;
	boughtSeat?: {
		description: string,
		price: number
	};
	fastTrackEnabled?: boolean;
	loungeEnabled?: boolean;
	skipMealEnabled?: boolean;
	added_bags?: number[];
	sportsEquipment?: { name: string, value: string, price: number }[];
	pets?: { name: string, value: string, price: number }[];
	musicInstruments?: { name: string, value: string, price: number }[];
	specialMeals?: { name: string, value: string, price: number, img: string };
	wifi?: { name: string, value: string, price: number }[];
	preferredBoardingEnabled?: boolean;
}

export interface Ancillaries {
	added?: Ancillaries;
}

export interface AncillariesLimitations {
	seat?: boolean;
	boughtSeat?: boolean;
	fastTrackEnabled?: boolean;
	preferredBoardingEnabled?: boolean;
	loungeEnabled?: boolean;
	added_bags?: boolean;
	sportsEquipment?: boolean;
	pets?: boolean;
	musicInstruments?: boolean;
	specialMeals?: boolean;
	wifi?: boolean;
}

export class PassengerFlightInfo {

	passenger: Passenger;
	stops?: Array<Ancillaries>;
	seat?: string = null;
	luggage?: number = 1;

	ancillaries_limitations?: AncillariesLimitations;

	constructor(passenger: Passenger, brand: FlightBrand) {
		this.passenger = passenger;

		if (brand == 'discount') {
			this.luggage = 0;
		}
	}


	createStopsAnciallaries(data: { stops: { id: string, label?: string }[] }): void {
		this.stops = data.stops.reduce((acc, cur) => {
			acc.push({ id: cur.id, seat: this.seat, luggage: this.luggage });
			return acc;
		}, Object.assign([], this.stops));
	}

}
